import React, { FC } from 'react';
import { CircularProgress } from '@material-ui/core';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik } from 'formik';
import { WelcomeModalSchema } from '../../../utils/validation';
import ActionData from '../../../types/ActionData';
import { mainColors } from '../../../assets/colors';
import './index.css';

interface Props {
  addingLocationApplication: boolean;
  addLocationApplication: ActionData;
  show: boolean;
  onSubmit: (values: any) => void;
  onClose: () => void;
}

const initialValues = {
  applicationType: '',
  '12BedCertification': ''
};

const ApplyNewLocationModal: FC<Props> = ({ show, addingLocationApplication, addLocationApplication, onSubmit, onClose }) => {
  const loadingIcon = addLocationApplication.error ? (
    <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color={mainColors.loadingBlue} className="modal-success-icon" />
  ) : (
    <CircularProgress size={70} />
  );

  const modalText = addLocationApplication.error ? 'The data could not be saved.' : '';

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={WelcomeModalSchema}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
      }}
    >
      {({ dirty, errors, isValid, values, setFieldValue, handleSubmit }) => {
        return (
          <Modal size="lg" show={show} onHide={onClose}>
            <Modal.Header closeButton>
              <FontAwesomeIcon icon={['fas', 'info-circle']} size='lg' className='modal-header-icon' />
              <Modal.Title>Getting Started</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {addingLocationApplication ? (
                addLocationApplication.loading || addLocationApplication.error ? (
                  <div className="modal-loading-container">
                    {loadingIcon}
                    <span className="modal-loading-text">
                      {modalText}
                      {addLocationApplication.error && (
                        <span dangerouslySetInnerHTML={{ __html: addLocationApplication.error.response.text }} />
                      )}
                    </span>
                  </div>
                ) : null
              ) : (
                <Form noValidate onSubmit={handleSubmit}>
                  <div style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '15px' }}>
                    Please choose application type below to get started.
                  </div>
                  <Row>
                    <Col xs={3} />
                    <Form.Group as={Col} xs={6}>
                      <Form.Control
                        as='select'
                        value={values.applicationType}
                        name='applicationType'
                        onChange={(event) => setFieldValue('applicationType', (event.target as HTMLInputElement).value)}
                      >
                        <option value="">Select an application type.</option>
                        <option value="non-residential">Non-Residential</option>
                        <option value="residential">Residential</option>
                      </Form.Control>
                      {errors.applicationType && <Form.Text className="form-error">{errors.applicationType}</Form.Text>}
                    </Form.Group>
                    <Col xs={3} />
                  </Row>
                  {values.applicationType === 'residential' && (
                    <Row style={{ marginTop: 15 }}>
                      <Col xs={3} />
                      <Form.Group as={Col} xs={6}>
                        <Form.Control
                          as='select'
                          value={values['12BedCertification']}
                          name='12BedCertification'
                          onChange={(event) => setFieldValue('12BedCertification', (event.target as HTMLInputElement).value)}
                        >
                          <option value="">Select an option:</option>
                          <option value="true">Need certification for 1-2 bed Adult Family Home</option>
                          <option value="false">Do Not Need certification for 1-2 bed Adult Family Home</option>
                        </Form.Control>
                        {errors['12BedCertification'] && <Form.Text className="form-error">{errors['12BedCertification']}</Form.Text>}
                      </Form.Group>
                      <Col xs={3} />
                    </Row>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button type='submit' variant='info' style={{ width: '150px' }}>
                      Continue
                    </Button>
                  </div>
                </Form>
              )}
            </Modal.Body>
          </Modal>
        );
      }}
    </Formik>
  );
};

export default ApplyNewLocationModal;
